import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-portal",
  "use": "icon-portal-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-portal\">\n<circle cx=\"16\" cy=\"16\" r=\"13\" fill=\"#3366FF\" />\n<rect x=\"9.90356\" y=\"10.5566\" width=\"12.0964\" height=\"8.46751\" rx=\"1\" fill=\"white\" />\n<rect x=\"14.1373\" y=\"16\" width=\"3.62893\" height=\"1.20964\" fill=\"#3366FF\" />\n<rect opacity=\"0.6\" x=\"15\" y=\"19\" width=\"2\" height=\"2\" fill=\"white\" />\n<rect opacity=\"0.6\" x=\"11.718\" y=\"21\" width=\"8.46751\" height=\"1.20964\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol